<template>
	<article class="small-12 flex documentUploadCard" v-if="doc">
		<a class="small-12 flex vertical-align justify-center" :href="doc.storage_url" target="_blank">
			<div class="small-12 flex vertical-align justify-center" @mouseover="showDocumentPreview = true">
				<div class="small-12 large-2 flex justify-center">
					<picture class="small-12 flex justify-center vertical-align borderRadius4 border dark">
						<i class="material-icons-outlined">insert_drive_file</i>
					</picture>
				</div>
				<div class="small-12 large-10 columns">
					<p class="small-12 text-overflow">
						{{doc.title}}
					</p>
				</div>
			</div>
		</a>
	</article>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'UploadedDocument',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			doc: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			showDocumentPreview: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>